import { CustomButton } from 'modules/auth/styles'
import { MainmenuUpgradeButton } from 'modules/mainmenu/styles'
import { changeTab_action, toggleSettingsModal_action } from 'store/actions'
import { connect } from 'react-redux'

const UpgradeButton = (props) => {
  return (
    <MainmenuUpgradeButton className='show-upgrade-button'>
      <CustomButton
        className='outline black btn-sm'
        onClick={() => {
          props.toggleSettingsModal(true)
          props.changeTab('billing')
        }}>
        Upgrade
      </CustomButton>
    </MainmenuUpgradeButton>
  )
}

const mapDispatchToProps = (dispatch) => ({
  toggleSettingsModal: (status) => dispatch(toggleSettingsModal_action(status)),
  changeTab: (value) => dispatch(changeTab_action(value))
})

export default connect(null, mapDispatchToProps)(UpgradeButton)
